if (process.env.PRODUCT.length) {
  require('components/fhApp/constants/' + process.env.PRODUCT + '-constants-staging');
}

require('components/fhApp/app');


// WEBPACK FOOTER //
// ./app.v2/entry-staging.js